import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter as Router, Route, Switch, useLocation } from "react-router-dom";
import "./App.css";

import "primereact/resources/themes/lara-light-purple/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import SideMenuBar from "./components/SideMenuBar/SideMenuBar";
import Calculadora from "./pages/Calculadora/Calculadora";
import CarrinhoDeCompras from "./pages/CarrinhoDeCompras/CarrinhoDeCompras";
import Carteira from "./pages/Carteira/Carteira";
import Configs from "./pages/Configuracoes/Configuracoes";
import ConfirmacaoInsercaoDeSaldo from "./pages/ConfirmacaoInsercaoDeSaldo/ConfirmacaoInsercaoDeSaldo";
import Conta from "./pages/Conta/Conta";
import ContaEditPassword from "./pages/Conta/ContaEditPassword";
import ContaInfoEdit from "./pages/Conta/ContaInfoEdit";
import Documentos from "./pages/Documentos/Documentos";
import EmailConfirmacao from "./pages/EmailConfirmacao/EmailConfirmacao";
import Home from "./pages/Home/Home";
import LandingPage from "./pages/LandingPage/LandingPage";
import Login from "./pages/LoginRegister/Login";
import NewPassword from "./pages/LoginRegister/NewPassword";
import Register from "./pages/LoginRegister/Register";
import ResetPassword from "./pages/LoginRegister/ResetPassword";
import MeusEnvios from "./pages/MeusEnvios/MeusEnvios";
import Notificacoes from "./pages/Notificacoes/Notificacoes";
import Perfil from "./pages/Perfil/Perfil";
// import PostagensConferidas from './pages/PostagensConferidas/PostagensConferidas';
import Tratativas from "./pages/Tratativas/Tratativas";
import WhatsApp from "./components/Footer/WhatsApp";
import MinhaLoja from "./components/LojaForm/MinhaLoja";
import MinhasLojas from "./pages/MinhasLojas/MinhasLojas";
import LojaFormEditPage from "./pages/LojaForm/LojaFormEditPage";
// import GerenciarAcessos from "./pages/GerenciarAcessos/GerenciarAcessos";
import PostagensConferidas from "./pages/PostagensConferidas/PostagensConferidas";
import LoteProcessamento from "./pages/LoteProcessamento/LoteProcessamento";
import Rastreio from "./pages/RastreioPublico/Rastreio";
import Relatorios from "./pages/Relatorios/Relatorios";

function SupportWidgets() {
  const location = useLocation();
  const isTrackingRoute = /^\/rastreio(\/|$)/.test(location.pathname);

  useEffect(() => {
    if (typeof window.zE !== "function") return;

    const zendeskAction = isTrackingRoute ? "hide" : "show";
    const safeZendeskCall = (widgetType) => {
      try {
        window.zE(widgetType, zendeskAction);
      } catch {
        return;
      }
    };

    window.zE(() => {
      safeZendeskCall("webWidget");
      safeZendeskCall("messenger");
    });
  }, [isTrackingRoute]);

  if (isTrackingRoute) return null;
  return <WhatsApp />;
}

function App() {
  const [isLogged, setIsLogged] = useState(false);
  const userLogged = useSelector((state) => state.isUserLogged);
  const isUserRegisterSuccessMessage = useSelector((state) => state.isUserRegister);
  const isLojaModal = useSelector((state) => state.modal);

  useEffect(() => {
    if (userLogged) {
      setIsLogged(true);
    }
  }, [isLogged, userLogged, isUserRegisterSuccessMessage, isLojaModal]);

  const callbackLogin = (usuario) => {
    if (usuario !== null) {
      setIsLogged(true);
    }
  };

  return (
    <div
      className={
        isUserRegisterSuccessMessage || isLojaModal === true ? `Flexfrete is-clipped` : `Flexfrete`
      }
    >
      <div className={`App`}>
        <Router onUpdate={() => window.scrollTo(0, 0)}>
          <Header isLogged={isLogged} />
          {isLogged === true ? <SideMenuBar /> : null}
          <div>
            <Switch>
              {isLogged === true ? (
                <div className="FlexFrete-content private">
                  <Route path="/perfil" component={Perfil} />
                  <Route path="/" component={Home} exact />
                  <Route path="/home" component={Home} />
                  <Route path="/carrinho" component={CarrinhoDeCompras} />
                  <Route path="/calculadora" component={Calculadora} />
                  <Route path="/carteira" component={Carteira} />
                  <Route path="/configuracoes" component={Configs}>
                    <Route path="/configuracoes/conta" component={Conta} />
                    <Route path="/configuracoes/restaurar-senha" component={ContaEditPassword} />
                    <Route path="/configuracoes/conta-editar" component={ContaInfoEdit} />

                    {<Route path="/configuracoes/minha-loja" component={MinhasLojas} />}
                    {<Route path="/configuracoes/loja/nova" component={LojaFormEditPage} />}
                    {<Route path="/configuracoes/loja/editar/:uuid" component={MinhaLoja} />}
                    {/* {
                      <Route
                        path="/configuracoes/gerenciar-acessos/:id"
                        component={GerenciarAcessos}
                      />
                    } */}
                    <Route path="/configuracoes/documentos" component={Documentos} />
                  </Route>
                  {/* <Route path="/integracoes" component={Integracoes} /> */}
                  <Route path="/envios" component={MeusEnvios} />
                  <Route path="/notificacoes" component={Notificacoes} />
                  {<Route path="/postagens" component={PostagensConferidas} />}
                  <Route path="/tratativas" component={Tratativas} />
                  <Route path="/confirmacaoInsercaoSaldo" component={ConfirmacaoInsercaoDeSaldo} />
                  <Route path="/lote" component={LoteProcessamento} />
                  <Route path="/relatorios" component={Relatorios} />
                </div>
              ) : (
                <div className="FlexFrete">
                  <Route path="/" component={LandingPage} exact={true} />
                  <Route path="/register" component={Register} />
                  <Route path="/login">
                    <Login callbackLogin={callbackLogin} />
                  </Route>
                  <Route path="/recuperarSenha" component={ResetPassword} />
                  <Route path="/restauroSenha" component={NewPassword} />
                  <Route path="/validacao" component={EmailConfirmacao} />
                  <Route path="/rastreio/:uuid?" component={Rastreio} />
                </div>
              )}
            </Switch>
            <SupportWidgets />
          </div>
          <Footer isLogged={isLogged} />
        </Router>
      </div>
    </div>
  );
}

export default App;
